import React from 'react'

import { BorderRadius } from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

const borderRadius = toPx(BorderRadius.MEDIUM)

export const Image: React.CSSProperties = {
  borderTopLeftRadius: borderRadius,
  borderTopRightRadius: borderRadius,
  borderBottomRightRadius: borderRadius,
  borderBottomLeftRadius: borderRadius,
}

export const ConnectedToPrevious: React.CSSProperties = {
  borderTopLeftRadius: 0,
  borderTopRightRadius: 0,
}

export const ConnectedToNext: React.CSSProperties = {
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
}
